import React from 'react';
import { Link } from 'react-router-dom';
import { grey800 } from 'material-ui/styles/colors';

import ShiftDetails from './ShiftDetails';

const upcomingShift = {
  textAlign: 'center',
  color: 'white',
  fontWeight: '400',
  height: '4rem',
  lineHeight: '4rem',
  borderRadius: '4px',
  marginTop: '2rem'
};

const Details = ({ bookings = [], car, openDialog }) => {
  const bar = () => {
    if (bookings.length && bookings[0].isUpcomingShift) {
      return (
        <div style={{ ...upcomingShift, backgroundColor: '#33691e' }}>
          UPCOMING SHIFT
        </div>
      );
    } else if (bookings) {
      return null;
    }
    return (
      <Link to="/book" style={{ textDecoration: 'none' }}>
        <div style={{ ...upcomingShift, backgroundColor: grey800 }}>
          BOOK NOW
        </div>
      </Link>
    );
  };

  return (
    <div>
      {bar()}

      {bookings.map((booking, i) => (
        <ShiftDetails
          key={booking.startTime}
          booking={booking}
          car={car}
          index={i}
          openDialog={openDialog}
        />
      ))}
    </div>
  );
};

export default Details;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Details.js